import {SortOrder} from '../sort-order';
import {FirmwareProcedureState} from "../firmware-procedure-state";
import {FirmwareType} from "../firmware-type";

export class FirmwareProcedureFilters {
  serialNumber: string;
  firmwareTypes: FirmwareType[];
  targetVersion: string;
  states: FirmwareProcedureState[];
  from: number;
  until: number;
  organizationUuids: string[];
  sortField: string;
  sortOrder: SortOrder;
}
